import React from "react";

import { useSnackbar } from "../../hooks/useSnackbar";
import useAuth from "../../routes/login/AuthContext";
import { Network } from "../../services/NetworkApi";
import { Grid } from "../../UI/Grid";
import { Radio } from "../../UI/Radio";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { WrapperWithTitle } from "../WrapperWithTitle";

interface IProps {
  l2?: Network | null;
  onChange: (key: string, value: boolean) => void;
  isDisabled?: boolean;
}

export const GenderSettingsView: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(false);
  const [view, setView] = React.useState(
    String(!!props.l2?.genderNetworkSettingsTransport.genderSelectionVisibleToOthers)
  );

  const handleChange = async ({ currentTarget: { value } }: React.SyntheticEvent<any>) => {
    setIsLoading(true);

    try {
      await props.onChange("genderSelectionVisibleToOthers", JSON.parse(value));

      setView(value);

      showSuccessSnackbar("Saved Changes");
    } catch (error) {
      showErrorSnackbar("An Error Occurred");
    }

    setIsLoading(false);
  };

  React.useEffect(() => {
    setView(String(!!props.l2?.genderNetworkSettingsTransport.genderSelectionVisibleToOthers));
  }, [props.l2?.genderNetworkSettingsTransport.genderSelectionVisibleToOthers]);

  return (
    <WrapperWithTitle title="Who can view user's selected gender?">
      <ReadOnlyWrapper>
        <Grid container spacing={2}>
          <Grid item>
            <Radio
              isDisabled={isLoading || isSuperAdminRead() || props.isDisabled}
              isChecked={view === String(true)}
              value={String(true)}
              label="Everyone"
              onChange={handleChange}
            />
          </Grid>
          <Grid item>
            <Radio
              isDisabled={isLoading || isSuperAdminRead() || props.isDisabled}
              isChecked={view === String(false)}
              value={String(false)}
              label="Only the user"
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </ReadOnlyWrapper>
    </WrapperWithTitle>
  );
};
